import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  h3 {
    margin-bottom: 30px;
    font-size: 20px;
  }

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }
    
  .current-card-container {
    display: flex;
    flex-direction: row;
  }

  .cards-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    white-space: pre-wrap;
    
    .active-card {
      font-weight: 600;
      font-size: 17px;
      justify-content: center;
      align-items: center;

      &-info {
        font-weight: normal;
        font-size: 15px;
      }
    }

    .separator {
      width: 100%;
      height: 1px;
      background-color: ${ ({ theme }) => theme.colors.grey };
      margin-top: 20px;
    }
  }
    
  .newcard-text {
    margin-bottom: 16px;
      font-weight: 600;
      font-size: 17px;
  }
  
  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
